<template>
  <div class="backdrop container">
    <div class="roll">
      <div class="height8"></div>
      <div class="pl-twelve" id="first">
        <div class="justified item-content">
          <span class="title">平台客服电话</span>
          <span class="time">人工服务时间 9:00 - 18:00</span>
        </div>
        <div class="phone van-hairline--surround">
          <!-- <img src="../../assets/img/telephone.png" alt /> -->
          <a href="tel:0752-2162292">0752-2162292</a>
        </div>
      </div>
      <div class="pl-twelve mt-eight">
        <div class="justified item-content">
          <span class="title required">问题类型</span>
          <span class="text flex-center" @click="showProblem = true">{{matter}}<van-icon name="arrow" /></span>
        </div>
        <div class="justified item-content van-hairline--top" v-if="fileId">
          <span class="title required">{{wordTitle}}名称</span>
          <span class="text van-ellipsis">{{wordName}}</span>
        </div>
        <div class="mt-five ">
          <textarea placeholder="描述您的问题（必填项，5-200个字符)" v-model.trim="content" maxlength="200" focusInput style="resize: none;"></textarea>
          <span>{{content.length}}/200</span>
        </div>
      </div>
      <div class="pl-twelve mt-eight">
        <div class="title item-content">上传凭证</div>
        <van-uploader v-model="fileList" multiple :max-count="10" preview-size="2rem" />
      </div>
      <div class="pl-twelve mt-eight">
        <div class="title item-content required">联系方式</div>
        <div class="contact van-hairline--surround">
          <input type="text" placeholder="请输入QQ、手机、邮箱等联系方式" v-model="contact" />
        </div>
      </div>
    </div>
    <div class="partakes" @click="submit">
      <div class="submit">确定提交</div>
    </div>
    <!-- 问题类型弹出层 -->
    <van-action-sheet v-model="showProblem" :actions="list" description="请选择问题类型" @select="switchTab" close-on-click-action />
  </div>
</template>
<script src="https://cdn.jsdelivr.net/npm/amfe-flexible"></script>
<script>
import { Toast } from "vant";
import { doFeedback, doFeedbackByExpert, uploadImageBase64ByExpert, msgSecCheck, uploadImageBase64, checkImg } from "@/api/buyer/index";
export default {
  data() {
    return {
      // 18软件不知道如何操作;19资源太少太旧了;20资源信息有误;21资源版权投诉;22软件功能建议;23软件bug反馈
      list: [
        { id: "18", name: "软件不知道如何操作" },
        { id: "9", name: "软件闪退" },
        { id: "19", name: "资源太少太旧了" },
        { id: "20", name: "资源信息有误" },
        { id: "21", name: "资源版权投诉" },
        { id: "22", name: "软件功能建议" },
        { id: "23", name: "软件bug反馈" },
        { id: "4", name: "其他问题" },
      ],
      feedbackType: 0,
      content: "",
      contact: this.GetQueryString("phone"),
      matter: "请选择",
      showProblem: false,
      fileList: [],
      fileId: this.GetQueryString("fileId") || "",
      wordName: this.GetQueryString("wordName"),
      wordTitle: "课件",
      androidAttrs: null,
      source: this.GetQueryString("source") || "",
      images: []
    };
  },
  methods: {
    returnBack() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //微信环境
        wx.miniProgram.getEnv(function (res) {
          if (res.miniprogram) {
            //小程序环境下逻辑
            wx.miniProgram.navigateBack({ delta: 1 });
          } else {
            //非小程序环境下逻辑
          }
        });
      } else {
        //非微信环境逻辑
        let u = navigator.userAgent,
          app = navigator.appVersion;
        let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
        let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        let isOS = isAndroid ? true : false;
        if (isOS) {
          // Android环境
          window.Android.closeHandsel();
        } else {
          // ios环境
          window.webkit.messageHandlers.closeHandsel.postMessage("");
        }
      }
    },
    switchTab(value) {
      this.feedbackType = value.id;
      this.matter = value.name;
    },
    async submit() {
      console.log('参数matter=', this.matter, 'content=', this.content);
      console.log('参数fileList=', this.fileList);
      if (this.matter == "请选择") {
        this.$toast("请选择问题类型");
        return false;
      }
      if (this.content.length == 0) {
        this.$toast("请描述您的问题");
        return false;
      }
      if (this.content.length < 5) {
        this.$toast("您描述的问题不少于5个字符");
        return false;
      }
      if (this.contact.length == 0) {
        this.$toast("请输入联系方式");
        return false;
      }
      if (this.fileList.length > 0) {
        Toast.loading({
          message: '图片上传中...',
          forbidClick: true,
          duration: 0,
        });
      }
      for (let i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i]) {
          const [_, fileContent] = this.fileList[i].content.split(',');
          // 接口问题，只能循环调用多个接口
          const baseImgRes = this.GetQueryString("type") == 'expert' ? await uploadImageBase64ByExpert({
            fileContent,
            type: 7
          }) : await uploadImageBase64({
            fileContent,
            type: 7
          })
          if (baseImgRes.appStatus.errorCode != 0) {
            return this.$toast(msgRes.appStatus.message);
          }
          this.images.push(`https://img.yamyamyam.com${baseImgRes.content.path}`)
          if (this.GetQueryString("type") != 'expert') {
            const checkImgRes = await checkImg({
              url: `https://img.yamyamyam.com${baseImgRes.content.path}`
            })
            if (checkImgRes.appStatus.errorCode != 0) {
              return this.$toast(checkImgRes.appStatus.message);
            }
          }
        }
      }
      if (this.GetQueryString("type") == 'expert') {
        console.log('参数images=', this.images);
        let fd = {
          userType: '7',
          feedbackType: '1',
          content: this.content,
          contact: this.contact,
          token: this.GetQueryString("token"),
          images: this.images,
          fileId: this.fileId
        }
        doFeedbackByExpert(fd).then(res => {
          if (res.appStatus.errorCode == 0) {
            Toast.clear();//关闭图片上传中toast
            this.$toast(res.appStatus.message);
            setTimeout(() => {
              this.returnBack();
            }, 1500);
          } else {
            Toast.clear();//关闭图片上传中toast
            this.$toast(res.appStatus.message);
          }
        });
      } else {
        const msgRes = await msgSecCheck({
          openid: '',
          scene: 2,
          content: this.content,
          matter: this.matter,
        })
        // console.log('文本提交结果',msgRes)
        if (msgRes.appStatus.errorCode != 0) {
          this.$toast(msgRes.appStatus.message);
          if (!this.fileList || this.fileList.length == 0) {
            setTimeout(() => {
              this.returnBack();
            }, 1500);
          }
          return false;
        }
        let fd = new FormData();
        fd.append("userType", this.fileId ? "6" : this.GetQueryString("token") ? "1" : "3"); //1 member; 2 seller; 3 游客
        fd.append("feedbackType", this.feedbackType);
        fd.append("content", this.content);
        fd.append("contact", this.contact);
        fd.append("token", this.GetQueryString("token"));
        for (let i = 0; i < this.fileList.length; i++) {
          fd.append("file" + [i + 1], this.fileList[i] ? this.fileList[i].file : "");
        }
        fd.append("fileId", this.fileId);
        doFeedback(fd, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }).then(res => {
          if (res.appStatus.errorCode == 0) {
            Toast.clear();//关闭图片上传中toast

            this.$toast(res.appStatus.message);
            setTimeout(() => {
              this.returnBack();
            }, 1500);
            // setTimeout(function() {

            // var ua = window.navigator.userAgent.toLowerCase();
            // if (ua.match(/MicroMessenger/i) == "micromessenger") {
            //   //判断是否是微信环境
            //   //微信环境
            //   wx.miniProgram.getEnv(function(res) {
            //     if (res.miniprogram) {
            //       // 小程序环境下逻辑
            //       wx.miniProgram.navigateBack({ delta: 1 });
            //     }
            //   });
            // }
            // window.webkit.messageHandlers.helpSuccess.postMessage('');
            // }, 1000);
          } else {
            Toast.clear();//关闭图片上传中toast

            this.$toast(res.appStatus.message);
          }
        });
      }
    },
  },
  created() {

    // 判断是否是安卓手机，是则是true
    const model = navigator.userAgent;
    this.androidAttrs = model.indexOf('Android') > -1 || model.indexOf('Linux') > -1
    if (this.GetQueryString("fileId")) {
      let index = { 8: 0, 10: 1, 11: 2 }[this.GetQueryString("typeId")];
      this.wordTitle = ["课件", "教案", "微课"][index];
      this.list = [
        { id: "15", name: "课件纠错" },
        { id: "16", name: "教案纠错" },
        { id: "17", name: "微课纠错" },
      ];
      this.switchTab(this.list[index])
    }
    document.title = "客服中心";
  }
};
</script>

<style lang="scss" scoped>
input {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font-weight: normal;
  vertical-align: baseline;
}
.flex-center {
  display: flex;
  align-items: center;
}
.justified {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
/deep/.van-action-sheet__description {
  height: 50px;
  font-size: 16px;
  font-weight: 800;
  color: #333333;
  margin-top: 10px;
  box-sizing: border-box;
}
/deep/.van-action-sheet__item {
  height: 50px;
  line-height: 50px;
  font-size: 15px;
  color: #1d1d1d;
}
.backdrop {
  height: 100vh;
  font-size: 17px;
  color: #333333;
  background-color: #f0f0f0;
}
.roll {
  text-align: left;
  padding-bottom: 100px;
}
.title {
  font-size: 16px;
  font-weight: 800;
  color: #3d4245;
}
.time {
  margin-left: 5px;
  font-size: 14px;
  color: #888888;
}
#first {
  .phone {
    height: 34px;
    line-height: 34px;
    font-size: 12px;
    text-align: center;
    box-sizing: border-box;
    img {
      width: 13px;
      height: 13px;
      vertical-align: middle;
    }
    a {
      color: #f52c19;
      margin-left: 3px;
      vertical-align: middle;
    }
  }
  [class*="van-hairline"]::after {
    border-color: #f52c19;
    border-radius: 40px;
  }
}
.item-content {
  height: 40px;
  line-height: 40px;
}
.text {
  max-width: 240px;
  display: inline-block;
  font-size: 14px;
  color: #888888;
}
.required::before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}
img {
  width: 10px;
  height: 28px;
  margin-left: 10px;
}
p {
  display: flex;
  align-items: center;
}
.label {
  width: 100%;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 14px;
  color: #333333;
}
.active {
  color: #ff1310;
}
.pl-twelve {
  padding: 0 12px 12px;
  background-color: #fff;
  border-radius: 8px;
  margin: 0 10px;
}
.mt-five {
  margin-top: 5px;
  padding: 9px 4px 4px 12px;
  font-size: 12px;
  background: #f8f8f8;
  border-radius: 10px;
  textarea {
    border: none;
    width: 100%;
    color: #333333;
    background: #f8f8f8;
    min-height: 90px;
  }
  textarea::placeholder {
    color: #b4b4b4;
  }
  span {
    text-align: right;
    display: block;
    color: #b4b4b4;
    padding: 0 10px 10px 0;
  }
}
.mt-eight {
  margin-top: 8px;
}
.contact {
  height: 40px;
  line-height: 40px;
  font-size: 12px;
  margin-top: 12px;
  border-radius: 5px;
  padding-left: 12px;
  input {
    width: 100%;
  }
}
.partakes {
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  margin: 0;
  text-align: center;
  background: #ffffff !important;
  z-index: 100;
  padding: 10px;
  box-sizing: border-box;
}
.submit {
  color: #fff;
  font-size: 15px;
  height: 40px;
  line-height: 40px;
  border-radius: 30px;
  background: linear-gradient(135deg, #ff4e64 0%, #fa2d1a 100%);
}
.height8 {
  height: 8px;
}
</style>